// AdminLogin
import React from 'react';

export default class AdminLogin extends React.Component {
  constructor(){
    super();
    this.state = { password: '' }
  }

  changeHandler(e) {
    e.preventDefault();
    this.setState({ password: e.target.value });
  }

  submitHandler(e) {
    e.preventDefault();
    const pwd = this.state.password;
    this.setState({ password: '' });
    this.props.submitLogin(pwd);
  }

  render() {
    return (
      <form className='content login' onSubmit={this.submitHandler.bind(this)}>
        <label htmlFor="password">Please type your password:</label>
        <input type="password" name="password" id="password" value={this.state.password} onChange={this.changeHandler.bind(this)} />
        {
          (() => {
            if (this.props.error){
              return <span className='alert'>{this.props.error}</span>
            }
          })()
        }
        <button className='btn btn-primary' value="Submit" onClick={this.submitHandler.bind(this)}>Submit</button>
      </form>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/admin/AdminLogin.jsx